module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps-wrapper"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "content",
    class: {
      'active': _vm.step === 'upload'
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("1")]), _vm._v("上传" + _vm._s(_vm.$t('common.project')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "content",
    class: {
      'active': _vm.step === 'convert'
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("2")]), _vm._v("转化 H5\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "content",
    class: {
      'active': _vm.step === 'complete'
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("3")]), _vm._v("分享链接\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66d61e1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/steps.vue
// module id = 928
// module chunks = 3